import { render, staticRenderFns } from "./DeliveryFormTypeSelect.vue?vue&type=template&id=4e32b4c3&lang=pug&"
import script from "./DeliveryFormTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./DeliveryFormTypeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports